module.exports = __webpack_public_path__ + "img/notepad.0b409188.png";